let Config = {};

//Config.REST_URL = 'https://apiint.houstonisd.org/';
//Config.REST_URL= 'http://localhost:62952/';
//Config.REST_URL= 'http://localhost/CroseService/';
//Config.REST_URL = 'https://apiint.houstonisd.org/';
//Config.REST_URL = 'https://apieadev.houstonisd.org/CroseService/';
//Config.REST_URL = "https://apiint.houstonisd.org/CroseService/";
Config.REST_URL = "https://pubapi.houstonisd.org/CroseService/";

export default Config;